const layer = {
	msg: (title, opt, fn) => {
		const layerHtml = `<div class="plugin-layer-box msg">${title}</div>`;
		$('body').append(layerHtml);

		if (opt) {
			setTimeout(() => {
				fn();
				$('.plugin-layer-box').remove();
			}, opt.time)
		} else {
			setTimeout(() => {
				$('.plugin-layer-box').remove();
			}, 2000)
		}
	},
	dialog: (title, btns, fun) => {
		const layerBox = document.createElement('div');
		layerBox.classList = 'plugin-layer-box dialog';
		const layerMask = document.createElement('div');
		layerMask.className= "plugin-layer-mask";
		layerMask.addEventListener('click', function(){
			$('.plugin-layer-box').remove();
		}, false);
		const layerMain = document.createElement('div');
		layerMain.className = "plugin-layer-main";
		const layerContent = document.createElement('div');
		layerContent.className = "plugin-layer-content";
		layerContent.innerHTML = title;
		const layerBtns = document.createElement('div');
		layerBtns.className = "plugin-layer-btns";
		for (let i = 0; i < btns.length; i++) {
			const btnItem = document.createElement('span');
			btnItem.className = 'plugin-layer-btn';
			btnItem.innerHTML = btns[i];
			layerBtns.appendChild(btnItem);
			btnItem.addEventListener('click', function(){
				$('.plugin-layer-box').remove();
				fun[i]();
			}, false);
		}
		layerBox.appendChild(layerMask);
		layerMask.appendChild(layerMain);
		layerMain.appendChild(layerContent);
		layerMain.appendChild(layerBtns);
		$('body').append(layerBox);
	}
}

export { layer }